module.exports = __webpack_public_path__ + "static/media/home-alt.502710c4.svg";